
import AppointmentService from './AppointmentService.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import SavedVehicle from 'JS/components/automotive/SavedVehicle.vue';
import { computed, defineComponent } from 'vue';
import { getAppointmentTitleString } from 'JS/automotive/auto-service-scheduler/utils/helpers';
import { ISavedVehicle, IServiceConfirmationResource } from 'JS/types/Automotive';
import { IWorkOrderConfirmationResource } from 'JS/types/Automotive';
import { IWorkOrderSummaryResource, WorkOrderAppointmentInfo, WorkOrderAppointmentInfoState, WorkOrderType } from 'JS/automotive/auto-service-scheduler/types/session';
import { PropType } from 'vue';

export default defineComponent({
	name: 'Appointment',
	components: {
		LinkButton,
		SavedVehicle,
		AppointmentService
	},
	props: {
		workOrder: {
			type: Object as PropType<IWorkOrderConfirmationResource>,
			required: true
		},
		past: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const orderType = computed<WorkOrderType>(() => props.workOrder.type);
		const orderId = computed(() => props.workOrder.orderId);
		const orderHash = computed(() => props.workOrder.orderHash);

		const selectedServices = computed<IServiceConfirmationResource[]>(() => props.workOrder.services);

		const appointmentInfo = computed<WorkOrderAppointmentInfo>(() => props.workOrder.appointmentInfo);

		const workOrderSummary = computed<IWorkOrderSummaryResource>(() => props.workOrder.workOrderSummary);

		const vehicle = computed<ISavedVehicle>(() => workOrderSummary.value.vehicleInfo);
		const vehicleLayout = computed(() => vehicle.value.iconType == null ? 'no-icon' : 'scheduler');

		// const startDate = computed<Date>(() => getAppointmentStartDate(appointmentInfo.value));

		const startDate = computed<string>(() => {
			if (!appointmentInfo.value) return null;

			switch (appointmentInfo.value.state) {
				case WorkOrderAppointmentInfoState.Dropoff:
					const startDate = appointmentInfo.value.selectedDate;
					return new Date(startDate).toLocaleDateString('en-us', {
						weekday: "long",
						month: "long",
						day: "numeric",
						year: "numeric"
					}) ?? null;
				case WorkOrderAppointmentInfoState.TimeSlot:
					const startTime = appointmentInfo.value.selectedTimeSlot.start;
					return new Date(startTime).toLocaleDateString('en-us', {
						weekday: "long",
						month: "long",
						day: "numeric",
						year: "numeric"
					}) ?? null;
				default:
					return null;
			}
		});

		const appointmentDate = computed(() => {
			return startDate.value;
		});

		const appointmentTime = computed(() => {
			const apptValue = appointmentInfo.value;
			switch (apptValue.state) {
				case WorkOrderAppointmentInfoState.Dropoff:
					return '9:00 AM';
				case WorkOrderAppointmentInfoState.TimeSlot:
					return new Date(apptValue.selectedTimeSlot.start).toLocaleTimeString('en-us', {
						hour: "numeric",
						minute: "numeric"
					}) ?? null;
				default:
					return null;
			}
		});

		const appointmentTitle = computed(() => getAppointmentTitleString(orderType.value));

		const appointmentDetailsLink = `/account/appointments/${orderId.value}/${encodeURIComponent(orderHash.value)}`;
		const calendarFileLink = computed(() => `/automotive-scheduler/add-to-calendar/${orderId.value}/${encodeURIComponent(orderHash.value)}`);

		const showServiceProduct = computed(() => orderType.value !== WorkOrderType.ServiceOnly);

		return {
			appointmentDate,
			appointmentDetailsLink,
			appointmentInfo,
			appointmentTime,
			appointmentTitle,
			calendarFileLink,
			selectedServices,
			showServiceProduct,
			vehicle,
			vehicleLayout,
			workOrderSummary
		};
	}
});
